import React, { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";

import Typography from "@mui/material/Typography";
import ApiHelper from "../../utillity/ApiHelper";
import APIURLConstants from "../../config/config";
import { useNavigate } from "react-router-dom";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import { useSiteState } from "../../hookState/SiteState";
// import { useState } from "@hookstate/core";
import ProductCard from "../../components/Product/ProductCard";
import RouteConstants from "../../constants/RouteConstant";
import { setPlanState } from "../../hookState/PlanState";
import Skeleton from "@mui/material/Skeleton";
import ProductLoadingCard from "../../components/Product/ProductLoadingCard";
import Blogbg from "../../assets/blog/blogbg.png";
import { NewFooter } from "../../components/NewFooter";

export const MyAccount = () => {
	const state = useSiteState();
	let navigate = useNavigate();
	const [products, setProducts] = useState([]);
	const [loading, setLoading] = useState(true);
	const [total, setTotal] = useState(50);

	const [snackBarProps, setSnackBarProps] = React.useState({
		openSnack: false,
		variant: "error",
		message: "",
	});
	const getProducts = () => {
		setLoading(true);
		const data = { user_id: state.user.id.get() };
		console.log(data);
		ApiHelper.post(APIURLConstants.GET_MY_PRODUCTS, data)
			.then((res) => {
				setLoading(false);
				setProducts(res.data.result.products);
				setPlanState(res.data.result.products);
			})
			.catch((error) => {
				setLoading(false);
				console.log(error);
			});
	};

	useEffect(() => {
		if (state.user.get()) {
			getProducts();
		} else {
			navigate(RouteConstants.LOGIN);
		}
	}, []);

	// useEffect(() => {
	// 	alert(products.length);
	// }, [products]);

	const removeProduct = (product_asin) => {
		if (state.user.get() !== "") {
			let data = { user_id: state.user.id.get(), asin: product_asin };
			ApiHelper.post(APIURLConstants.REMOVE_MYPRODUCT_ITEM, data)
				.then((res) => {
					console.log(res);
					if (res.data.success) {
						setSnackBarProps({
							openSnack: true,
							variant: "success",
							message: "Product removed",
						});
					}
					getProducts();
				})
				.catch((error) => {
					console.log(error);
					setSnackBarProps({
						openSnack: true,
						variant: "error",
						message: "Something wrong",
					});
				});
		}
	};

	// useEffect(() => {
	// 	console.log(search);
	// 	console.log(search.length);

	// 	getProducts();

	// 	//getProducts();
	// }, [search]);
	return (
		<>
			<Box
				sx={{
					background: `url(${Blogbg})`,
					backgroundSize: "100%",
					height: { xs: 180, md: 200 },
					// width: "auto",
				}}
			>
				<Box
					display={"flex"}
					flexDirection={"column"}
					justifyContent={"center"}
					textAlign={"center"}
					height={{ xs: 170, md: 180 }}
				>
					{/* <Typography
						component={"h4"}
						variant="inherit"
						fontSize="20"
						fontWeight={500}
						color={"#ffff"}
					>
						Products
					</Typography> */}
					<Typography
						component={"h1"}
						variant="inherit"
						fontSize="58"
						fontWeight={600}
						color={"#ffff"}
					>
						My Account
					</Typography>
				</Box>
			</Box>

			{loading ? (
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						// height: "100%",
						width: "1280px",
						justifyContent: "center",
						alignContent: "center",
						alignItems: "center",
					}}
				>
					<CircularProgress
						sx={{
							color: "secondary.main",
						}}
					/>
				</Box>
			) : (
				<>
					<Box
						sx={{
							display: "flex",
							flexWrap: "wrap",
							flexDirection: { xs: "column", md: "row" },
							justifyContent: "center",

							// paddingLeft: { xs: "0", md: "4em" },
							padding: { xs: "0", md: 4 },
						}}
					>
						<Box
							display={"flex"}
							justifyContent={"center"}
							flexWrap={"wrap"}
							alignSelf={"center"}
							mx={"auto"}
							p={4}
							gap={2}
						>
							{products.length > 0 ? (
								products.map((product, index) => {
									return (
										<ProductCard
											key={index}
											data={product}
											myAccount={true}
											removeProduct={removeProduct}
										/>
									);
								})
							) : (
								<Typography fontSize={15} color="initial" padding={4}>
									No Data Found{" "}
								</Typography>
							)}
						</Box>
					</Box>
				</>
			)}
		</>
	);
};
